import { define } from 'wicked-elements'
import SnapSlider from '@tannerhodges/snap-slider'

define('[data-component="slider"]', {
  init() {
    this.id = this.element.id
    this.$slider = this.element.querySelector('[data-slider]')
    this.$caption = this.element.querySelector('figcaption')
    this.$prev = [...this.element.querySelectorAll('[data-prev]')]
    this.$next = [...this.element.querySelectorAll('[data-next]')]
    this.$current = this.element.querySelector('[data-current]')

    this.slider = new SnapSlider(this.$slider, {
      loop: true,
      on: {
        change: () => {
          const $current = this.slider.slides[this.slider.current - 1]
          this.$caption.innerHTML = $current.getAttribute('data-caption') || '&nbsp;'
          this.$current.innerHTML = this.slider.current
        }
      }
    })

    this.goToNext = this.goToNext.bind(this)
    this.goToPrev = this.goToPrev.bind(this)
  },
  connected () {
    this.$next.forEach(button => button.addEventListener('click', this.goToNext))
    this.$prev.forEach(button => button.addEventListener('click', this.goToPrev))
  },
  disconnected () {
    this.$next.forEach(button => button.removeEventListener('click', this.goToNext))
    this.$prev.forEach(button => button.removeEventListener('click', this.goToPrev))
  },
  goToNext () {
    this.slider.goto('next', { immediate: true })
  },
  goToPrev () {
    this.slider.goto('prev', { immediate: true })
  }
})
